/* Name: Main.tsx
* Copyright: (c) DA-Design Oy
* Creation date: 15.05.2024   (EKn)
* Modified: 07.11.2024 (PKo)
* 
* Description: 
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig.js';

const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root')!);

const startApplication = async () => {
  await msalInstance.initialize();

  const redirectResult = await msalInstance.handleRedirectPromise();
  if (redirectResult?.account) {
    msalInstance.setActiveAccount(redirectResult.account);
  } else if (!msalInstance.getActiveAccount()) {
    const [firstAccount] = msalInstance.getAllAccounts();
    if (firstAccount) {
      msalInstance.setActiveAccount(firstAccount);
    }
  }

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
};

startApplication().catch((error: unknown) => {
  console.error('MSAL initialization failed:', error);
  root.render(<p role="alert">Unable to initialize sign-in. Please refresh the page or contact support.</p>);
});
